export const STATUS = {
  NOT_STARTED: 1,
  ANSWERING: 2,
  SUBMITTED: 3,
  ASSESSMENT_GRADED_COMPLETED: 4,
  ASSESSMENT_EVALUATION_COMPLETED: 5,
  IMPROVEMENT_PROPOSAL_COMPLETED: 6,
  ASSESSMENT_COMPLETED: 7,
  RE_ASSESSMENT: 8,
  RE_ASSESSMENT_GRADED_COMPLETED: 9,
  RE_ASSESSMENT_EVALUATION_COMPLETED: 10,
  RE_ASSESSMENT_COMPLETED: 11,
  APPLIED_FOR_CERTIFICATE: 12,
  CERTIFICATED_ISSUED: 13,
  CANCELLED: 14,
};
